<template>
    <div>
        <xx-link
            v-for="item  in linkList"
            :key="item.text"
            v-bind="omit(item, ['onClick'])"
            @click="item.onClick"
        ></xx-link>
    </div>
</template>

<script>
import { get, omit, noop } from '@lsfe/tools';

export default {
    name: 'formatLink',
    props: {
        value: {},
        scope: {},
        formatter: {
            type: [Function, String, Array],
            required: true
        },
        target: {
            type: String,
            default: ''
        },
        text: {
            type: String,
            default: ''
        }
    },
    computed: {
        linkList() {
            const { scope, formatter } = this;

            const { row, column, $index } = scope;

            const cellValue = get(row, column.property);

            if (typeof formatter === 'string') {
                // 模板字符串模式
                return [this.formatLinkOption(formatter, row, column.property)];
            }

            if (Array.isArray(formatter)) {
                // 多个模板字符串模式
                return formatter.map(tplStr => this.formatLinkOption(tplStr, row, column.property));
            }

            // 回调函数模式
            const attrs = formatter(row, column, cellValue, $index);

            return [].concat(attrs).map(itemAttrs => {
                return {
                    text: cellValue,
                    ...itemAttrs,
                    onClick: itemAttrs.onClick || noop
                };
            }).filter(v => v.text);
        }
    },
    data() {
        return {
            omit
        };
    },
    methods: {
        formatLinkOption(tplStr, row, prop) {
            const { target, text } = this;

            const linkOption = {
                path: (tplStr || '').replace(/{([^{,}]*)}/ig, (v, v1) => row[v1]),
                onClick: noop, // 模板字符串模式暂不支持事件
                text: text || row[prop] || '--'
            };

            if (target) {
                linkOption[target] = target;
            }

            return linkOption;
        }
    }
};
</script>
